// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Footer from './Footer';
import MobileLayout from './MobileLayout';
import TopNav from './TopNav';
import { mobileView } from '../../_common/api/utility';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: ${({ mobile }) => mobile ? 'center' : 'space-between'};
    align-items: center;
    position: relative;
    min-height: ${({ mobile }) => mobile ? '-webkit-fill-available' : '100vh'};
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
`;
const Content = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    width: 100vw;
    padding: 0 0 2em 0;
    height: 100px;
    margin-bottom: 1.3em;
    overflow: auto;
    scrollbar-gutter: stable;
    
    ${({ mobile, height }) => mobile && `
        height: ${height - 120}px;
        flex-grow: 0;
        padding: 0 0;
        overflow: overlay;
    `}
`;

const Layout = ({ children, ...props }) => {
    const {
        state: {
            // mobileView
            site_config
        },
    } = useGlobalState();

    const [innerHeight, setInnerHeight] = useState(window.innerHeight);
    useEffect(() => {
        const updateWidth = () => { setInnerHeight(window.innerHeight) }
        window.addEventListener('resize', updateWidth);
        return () => window.removeEventListener('resize', updateWidth);
    });

    const [showHeader, setShowHeader] = useState(window.pageYOffset > 400);
    useEffect(() => {
        const handleHeaderDrop = () => setShowHeader(window.pageYOffset > 400)
        document.addEventListener('scroll', handleHeaderDrop);
        return () => document.removeEventListener('scroll', handleHeaderDrop);
    });

    const theme = useTheme();

    if (mobileView) return <MobileLayout children={children} />

    document.getElementById('themeColor').content = theme.body;

    if (!site_config.has_ecom) {
        return (
            <Wrapper mobile={mobileView}>
                <Content id='ecom_content_wrapper' mobile={mobileView} height={innerHeight}>
                    {children}
                </Content>
            </Wrapper>
        )
    }

    return (
        <Wrapper mobile={mobileView}>
            <TopNav showMini={showHeader} />
            <Content id='ecom_content_wrapper' mobile={mobileView} height={innerHeight}>
                {children}
            </Content>
            <Footer />
        </Wrapper>
    );
}

export default Layout;